<template>
    <div class="d-flex flex-row headbar">
        <ul class="navbar-nav">
            <li class="nav-item">
                <router-link class="nav-link menu-content" to="/"
                    >基礎編 TOP</router-link
                >
            </li>
            <li class="nav-item">
                <el-dropdown>
                    <span class="el-dropdown-link">
                        学習項目一覧<i
                            class="el-icon-arrow-down el-icon--right"
                        ></i>
                    </span>
                    <template #dropdown>
                        <el-dropdown-menu>
                            <el-dropdown-item>
                                <router-link
                                    class="nav-link dropdown-item"
                                    to="/menu/pswd"
                                    >パスワード設定</router-link
                                ></el-dropdown-item
                            >
                            <el-dropdown-item>
                                <router-link
                                    class="nav-link dropdown-item"
                                    to="/menu/mail"
                                    >メール利用</router-link
                                ></el-dropdown-item
                            >
                            <el-dropdown-item>
                                <router-link
                                    class="nav-link dropdown-item"
                                    to="/menu/web"
                                    >ウェブ利用</router-link
                                ></el-dropdown-item
                            >
                            <el-dropdown-item>
                                <router-link
                                    class="nav-link dropdown-item"
                                    to="/menu/information"
                                    >情報漏洩</router-link
                                ></el-dropdown-item
                            >
                            <el-dropdown-item>
                                <router-link
                                    class="nav-link dropdown-item"
                                    to="/menu/incident"
                                    >インシデント対応</router-link
                                ></el-dropdown-item
                            >
                        </el-dropdown-menu>
                    </template>
                </el-dropdown>
            </li>
        </ul>
    </div>
</template>

<style lang="scss" scoped>
.headbar {
    background-color: #ffe0c1;
    overflow: scroll;
}

.navbar-nav {
    flex-direction: row;
    padding: 0 10px;
}
.nav-item {
    margin: 15px;
    white-space: nowrap;
}

.nav-link {
    color: black;
}
</style>